import Vue from 'vue'

Vue.prototype.$linkGenerator = function (link, file, params) {
  var pramsText = ''
  if (typeof params === 'object') {
    var str = []
    for (var p in params) {
      if (Object.prototype.hasOwnProperty.call(params, p)) {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(params[p]))
      }
    }
    pramsText = str.join('&')
  }

  return file
    ? localStorage.getItem('site') + link + '?' + pramsText
    : localStorage.getItem('site') + '/api' + link + '?' + pramsText
}

Vue.prototype.$setParams = function (params) {
  var url = new URL(window.location.href)
  var search_params = url.searchParams
  Object.keys(params).forEach(function (key) {
    search_params.set(key, params[key])
  })
  url.search = search_params.toString()
  location.replace(window.location.href.split('?')[0] + url.search)
}

Vue.prototype.$isFloat = function (value) {
  if (typeof value === 'number' && !Number.isNaN(value) && !Number.isInteger(value)) {
    return true
  }

  return false
}

Vue.prototype.$dynamicSort = function (params) {
  var sortOrder = params.orderType === 'asc' ? -1 : 1
  return function (a, b) {
    var result =
      a[params.orderBy] < b[params.orderBy] ? -1 : a[params.orderBy] > b[params.orderBy] ? 1 : 0
    return result * sortOrder
  }
}

Vue.prototype.$getParams = function () {
  var searchParams = new URLSearchParams(window.location.href.split('?')[1]).entries()
  let result = {}
  for (let entry of searchParams) {
    result[entry[0]] = entry[1]
  }
  return result
}

Vue.prototype.$fixDate = function (str) {
  let arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
  if (typeof str === 'string') {
    for (var i = 0; i < 10; i++) {
      str = str.replace(arabicNumbers[i], i)
      str = str.replace('ص', 'am').replace('م', 'pm')
    }
  }
  return str
}

Vue.prototype.$moneyFormat = function (int) {
  if (isNaN(int) || isNaN(parseFloat(int))) int = 0
  let number = parseFloat(int)
  if (Vue.prototype.$option.show_currency) {
    var str = number.toLocaleString(undefined, {
      style: 'currency',
      currency: Vue.prototype.$option.currency,
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    })
  } else {
    str = number.toLocaleString(undefined, {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    })
  }

  return str
}

Vue.prototype.$dateFormat = function (int, inputDate) {
  if (typeof int === 'string' && !isNaN(Date.parse(int))) {
    int = new Date(int).getTime() / 1000
  }

  if (isNaN(int) || isNaN(parseFloat(int))) {
    int = Date.now() / 1000
  }
  var date = new Date(int * 1000)
  var hours = date.getHours()
  var minutes = date.getMinutes()
  var amOrPm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours ? hours : 12
  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  var outDate =
    ('0' + date.getDate()).slice(-2) +
    '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    date.getFullYear()
  var reversedDate =
    date.getFullYear() +
    '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + date.getDate()).slice(-2)

  var outTime = hours + ':' + minutes + ' ' + amOrPm
  let str = Vue.prototype.$option.show_time ? outDate + ', ' + outTime : outDate
  if (inputDate == 'date') {
    return outDate
  }
  if (inputDate == 'time') {
    return outTime
  }
  if (inputDate) {
    str = reversedDate + ' ' + outTime
  }
  return str
}
Vue.prototype.$TimeFormat = function (time) {
  return time.slice(0, 5)
}
Vue.prototype.$fullDateFormat = function (timestamp) {
  // Create a Date object using the timestamp (multiply by 1000 because JavaScript uses milliseconds)
  const date = new Date(timestamp * 1000)

  // Format the date to "YYYY-MM-DD HH:mm:ss"
  const formattedDate = date.toISOString().slice(0, 19).replace('T', ' ')

  return formattedDate
}

Vue.prototype.$nowDate = function (after) {
  var today = new Date()
  var hours = today.getHours()
  var minutes = today.getMinutes()
  var amOrPm = hours >= 12 ? 'pm' : 'am'
  hours = hours % 12
  hours = hours ? hours : 12
  minutes = minutes < 10 ? '0' + minutes : minutes
  if (after) {
    today.setDate(today.getDate() + 5)
  }
  var outDate =
    today.getFullYear() +
    '-' +
    ('0' + (today.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + today.getDate()).slice(-2)
  return outDate + ' ' + hours + ':' + minutes + ' ' + amOrPm
}

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
})
